import { Button } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import { zendesk } from '../shared/zendesk/url';
import MaintenanceImg from './assets/maintenance.webp';

const Maintenance = () => {
  return (
    <div className={center({ height: '100vh', bg: 'background.default.level-0' })}>
      <div
        className={center({ flexFlow: 'column', maxWidth: '726px', textAlign: 'center', p: { base: 16, tablet: 0 } })}
      >
        <img
          src={MaintenanceImg.src}
          alt='maintenance'
          className={css({ w: '100%', maxW: 604, aspectRatio: '604/336' })}
        />
        <h1
          className={css({
            textStyle: 'Display/L',
            px: 12,
            mb: 16,
            mt: { base: 8, tablet: 20 },
            color: 'content.default.level-4',
            textWrap: 'balance',
          })}
        >
          We’re working hard to serve you better.
        </h1>
        <p
          className={css({
            textStyle: 'Text/L/Regular',
            px: 12,
            mb: { base: 30, tablet: 60 },
            color: 'content.default.level-1',
          })}
        >
          Our app is temporarily unavailable for maintenance. We appreciate your understanding as we work to improve
          your experience. Thank you for your patience.
        </p>
        <Button
          hierarchy='primary'
          size='large'
          as='a'
          newTab
          href={zendesk.getUrl('RequestNew')}
          label='Contact us for support'
        />
      </div>
    </div>
  );
};

export default Maintenance;
